module.exports = __webpack_public_path__ + "assets/images/branch/cases/06.jpg";